import React, { useState } from 'react';
import { View, TextInput, TouchableOpacity, Platform } from 'react-native';
import { homeStyles } from '../styles/HomeStyles';

export function SearchBar({ onSearch, value, onChangeText, onSubmit, placeholder, color = '#000000' }) {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <View style={[homeStyles.searchContainer, { borderBottomColor: color, borderOpacity: 0.5 }]}>
      <TextInput
        style={[homeStyles.searchInput, { color }]}
        placeholder={isFocused ? '' : (placeholder || "Search for venues by name, city, state, affiliate...")}
        placeholderTextColor={color}
        placeholderStyle={{ fontFamily: 'VastagoGrotesk', fontWeight: '400', opacity: 0.6 }}
        value={value}
        onChangeText={onChangeText}
        onSubmitEditing={onSubmit}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        returnKeyType="search"
        autoCorrect={false}
        autoCapitalize="none"
        accessibilityLabel="Search venues"
        accessibilityHint="Enter venue name, city, state, or affiliate"
      />
      {Platform.OS === 'web' && (
        <TouchableOpacity 
          style={homeStyles.searchIcon} 
          onPress={onSubmit}
          accessibilityLabel="Submit search"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z" fill={color}/>
          </svg>
        </TouchableOpacity>
      )}
    </View>
  );
} 